<template>
  <div class="home-container">
<!--    首页，静态视频-->
    <video
      class="bg-video"
      src="https://haigui-app-1368936209.cos.ap-beijing.myqcloud.com/files/staticFiles/indexVideo.mp4"
      autoplay
      muted
      playsinline
    ></video>
    <div class="hero-text">
<!--      <h1>交易<br>高雅的艺术</h1>-->
    </div>
  </div>
</template>

<script setup>
import { defineOptions } from 'vue'
defineOptions({ name: 'HomePage' })
</script>

<style scoped>
.home-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.bg-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  z-index: 1;
}
.hero-text {
  position: absolute;
  top: 54%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  z-index: 2;
  text-align: center;
  text-shadow: 0 4px 24px rgba(0,0,0,0.5);
  width: 100vw;
}
.hero-text h1 {
  font-size: 2.2rem;
  font-weight: 700;
  line-height: 1.2;
  margin: 0;
}
@media (max-width: 768px) {
  .hero-text h1 {
    font-size: 1.3rem;
  }
}
</style> 